import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

import apiService from '../../services/apiServices';

// Async thunk for fetching shifts
export const fetchShifts = createAsyncThunk('shifts/fetchShifts', async () => {
    const response = await apiService.get('shifts');
    return response.data;
});

// Async thunk for creating a new shift
export const createShift = createAsyncThunk('shifts/createShift', async (shiftData) => {
    const response = await apiService.post('shifts', shiftData);
    return response.data;
});

// Async thunk for updating a shift
export const updateShift = createAsyncThunk('shifts/updateShift', async ({ id, shiftData }) => {
    const response = await apiService.put(`shifts/${id}`, shiftData);
    return response.data;
});

// Async thunk for deleting a shift
export const deleteShift = createAsyncThunk('shifts/deleteShift', async (id) => {
    await apiService.delete(`shifts/${id}`);
    return id; // Return the id to remove it from the state
});

export const checkTodayShift = createAsyncThunk('shifts/checkTodayShift', async (userId) => {
    console.log("checkTodayShift...start")
    const response = await apiService.get(`shifts/today/${userId}`);
    console.log("checkTodayShift...end ", response.data)
    return response.data;
});

export const closeShift = createAsyncThunk('shifts/closeShift', async ({ shiftId, data }) => {
    const response = await apiService.post(`shifts/${shiftId}/close`, data);
    return response.data;
});

export const updateShiftCash = createAsyncThunk('shifts/updateShiftCash', async ({ shiftId, data }) => {
    const response = await apiService.patch(`shifts/${shiftId}/cash`, data);
    return response.data;
});

export const closeAllActiveShifts = createAsyncThunk('shifts/closeAllActiveShifts', async (notes) => {
    const response = await apiService.post('shifts/close-all-active', { notes });
    return response.data;
});



export const getCurrentShift = createAsyncThunk(
    'currentShift/getCurrentShift',
    async (userId, { rejectWithValue }) => {
        try {
            const response = await apiService.get(`shifts/${userId}/current-shift`);

            return response.data;
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

const shiftsSlice = createSlice({
    name: 'shifts',
    initialState: {
        shifts: [],
        loading: false,
        error: null,
        todayShift: false,
        shift: null,
    },
    reducers: {
        resetShiftState: (state) => {
            state.todayShift = false;
            state.shift = null;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(getCurrentShift.pending, (state) => {
                state.loading = true;
                // state.shift = null // Removed to prevent UI flicker and race conditions
            })
            .addCase(getCurrentShift.fulfilled, (state, action) => {
                state.loading = false;
                const data = action.payload;
                state.shift = data;
                // If we got a shift, then todayShift must be true
                if (data && data._id) {
                    state.todayShift = true;
                }
            })
            .addCase(getCurrentShift.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || action.error.message;
                state.shift = null;
            })
            .addCase(closeShift.pending, (state) => {
                state.loading = true;
            })
            .addCase(closeShift.fulfilled, (state, action) => {
                state.loading = false;
                const index = state.shifts.findIndex(shift => shift._id === action.payload._id);
                if (index !== -1) {
                    state.shifts[index] = action.payload; // Update the closed shift
                }
                if (state.shift && state.shift._id === action.payload._id) {
                    state.shift = null;
                    state.todayShift = false;
                    localStorage.removeItem('pos_active_shift_id');
                }
            })
            .addCase(closeShift.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            })
            .addCase(checkTodayShift.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(checkTodayShift.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.todayShift = action.payload;
                console.log("state.todayShift", action.payload);
            })
            .addCase(checkTodayShift.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.error.message;
            })
            .addCase(fetchShifts.pending, (state) => {
                state.loading = true;
            })
            .addCase(fetchShifts.fulfilled, (state, action) => {
                state.loading = false;
                state.shifts = action.payload;
            })
            .addCase(fetchShifts.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            })
            .addCase(createShift.fulfilled, (state, action) => {
                state.shifts.push(action.payload);
                state.todayShift = true;
                state.shift = action.payload;
            })
            .addCase(updateShift.fulfilled, (state, action) => {
                const index = state.shifts.findIndex(shift => shift._id === action.payload._id);
                if (index !== -1) {
                    state.shifts[index] = action.payload;
                }
            })
            .addCase(updateShiftCash.fulfilled, (state, action) => {
                state.shift = action.payload.shift;
            })
            .addCase(closeAllActiveShifts.pending, (state) => {
                state.loading = true;
            })
            .addCase(closeAllActiveShifts.fulfilled, (state, action) => {
                state.loading = false;
                // Full reload of shifts might be cleaner since many changed
            })
            .addCase(closeAllActiveShifts.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            })
            .addCase(deleteShift.fulfilled, (state, action) => {
                state.shifts = state.shifts.filter(shift => shift._id !== action.payload);
            });
    },
});

export const { resetShiftState } = shiftsSlice.actions;
export default shiftsSlice.reducer;